import { get } from 'lodash';

const validateAttendeeReviewForm = ({ stars, review_text }, props) => {
  return {
    _error: get(props, 'review.complete') && 'This review has already been submitted',
    stars: !stars,
    review_text: !review_text || 5 > review_text.length
  };
};

export default validateAttendeeReviewForm;
